var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 17.3334C13.9061 18.099 14.6366 18.7324 15.4756 19.1907C16.3145 19.649 17.2422 19.9216 18.1957 19.9899C19.1492 20.0582 20.1063 19.9206 21.002 19.5865C21.8976 19.2524 22.711 18.7295 23.3868 18.0534L27.3868 14.0534C28.6012 12.7961 29.2732 11.1121 29.258 9.36411C29.2428 7.61613 28.5417 5.94405 27.3056 4.70799C26.0696 3.47194 24.3975 2.77081 22.6495 2.75562C20.9015 2.74043 19.2175 3.4124 17.9602 4.62678L15.6668 6.90678",
    stroke: "#101828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6664 14.6666C18.0938 13.9011 17.3633 13.2677 16.5244 12.8094C15.6855 12.351 14.7578 12.0785 13.8042 12.0102C12.8507 11.9419 11.8937 12.0795 10.998 12.4136C10.1023 12.7477 9.28896 13.2705 8.61311 13.9466L4.61311 17.9466C3.39872 19.204 2.72676 20.888 2.74195 22.636C2.75714 24.384 3.45827 26.056 4.69432 27.2921C5.93037 28.5282 7.60246 29.2293 9.35044 29.2445C11.0984 29.2597 12.7824 28.5877 14.0398 27.3733L16.3198 25.0933",
    stroke: "#101828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.117ef0a62dc2c519e7e5c8d793f145d4.svg";
export { ForwardRef as ReactComponent };